import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO title="Знижка 30% на програму Соната" />
    <div className="text-center p-20">
      <h1 className="mb-10">Тут нічого нема ...</h1>
      <a className="text-blue-600" href="https://sonatazvit.com.ua/uk/">Перейти на головну сторінку</a>
    </div>
  </Layout>
)

export default IndexPage